export class FileHelper {
    static validateFileName(fileName: string): { isValid: boolean; errorMessage?: string } {
        if (!fileName || fileName.trim() === '') {
            return { isValid: false, errorMessage: 'File name is required.' };
        }

        const trimmedFileName = fileName.trim();
        const validExtensions = ['.xlsx', '.csv'];
        const hasValidExtension = validExtensions.some(ext => 
            trimmedFileName.toLowerCase().endsWith(ext)
        );

        if (!hasValidExtension) {
            return { 
                isValid: false, 
                errorMessage: 'File must have a valid extension (.xlsx or .csv).' 
            };
        }

        if (trimmedFileName.includes('/') || trimmedFileName.includes('\\')) {
            return { 
                isValid: false, 
                errorMessage: 'File name should only contain the filename, not a path. Use the subpath field for folder structure.' 
            };
        }

        const invalidChars = /[<>:"|?*\\/]/;
        if (invalidChars.test(trimmedFileName)) {
            return { 
                isValid: false, 
                errorMessage: 'Filename contains invalid characters. Only letters, numbers, spaces, hyphens, underscores, and dots are allowed.' 
            };
        }

        return { isValid: true };
    }

    static validateSubPath(subPath: string): { isValid: boolean; errorMessage?: string } {
        if (!subPath || subPath.trim() === '') {
            return { isValid: true };
        }

        const trimmedSubPath = subPath.trim();

        if (trimmedSubPath.includes('/') || trimmedSubPath.includes('\\')) {
            return { 
                isValid: false, 
                errorMessage: 'Subpath must be simple text without path separators (e.g., "MyFolder", not "folder/subfolder").' 
            };
        }

        const invalidChars = /[<>:"|?*\\/]/;
        if (invalidChars.test(trimmedSubPath)) {
            return { 
                isValid: false, 
                errorMessage: 'Subpath contains invalid characters. Only letters, numbers, spaces, hyphens, and underscores are allowed.' 
            };
        }

        return { isValid: true };
    }

    static validateFilePathCombination(fileName: string, subPath: string): { isValid: boolean; errorMessage?: string } {
        const fileNameValidation = this.validateFileName(fileName);
        if (!fileNameValidation.isValid) {
            return fileNameValidation;
        }

        const subPathValidation = this.validateSubPath(subPath);
        if (!subPathValidation.isValid) {
            return subPathValidation;
        }

        return { isValid: true };
    }
}
